class SortCollection extends HTMLDetailsElement {
  connectedCallback() {
    this.CollectionFiltersForm = document.querySelector('product-filters-form') || null;
    const closeClickOutside = (event) => {
      if (!this.contains(event.target)) {
        this.open = false;
      }
    };
    this.addEventListener('toggle', (event) => {
      event.target.open
        ? document.addEventListener('click', closeClickOutside)
        : document.removeEventListener('click', closeClickOutside);
    });
    this.addEventListener('change', (event) => this.handleChange(event));
  }
  handleChange(event) {
    const value = event.target.value;
    const label = this.querySelector(`label[for="${event.target.id}"]`)?.innerHTML;
    // Set the right url sort_by parameter
    const url = new URL(window.location);
    let params = new URLSearchParams(url.search);
    params.delete('sort_by');
    // Update view param when not empty
    if (value != '') {
      params.set('sort_by', value);
      // Call method from class component and render the collection results
      this.CollectionFiltersForm?.renderPage(params.toString());
    }
    // Close the details element and update the selected value
    this.open = false;
    if (label) this.querySelector('[data-selected]').textContent = label;
  }
}

if (!customElements.get('sort-collection')) {
  customElements.define('sort-collection', SortCollection, { extends: 'details' });
}
